import React from 'react';
import { getLocale } from '../locale';
import Button from '../Button';
import ConfigConsumer from '../ConfigConsumer';
export default function DropdownConfirmButtonPanel(_ref) {
  var _ref$changeImmediatel = _ref.changeImmediately,
      changeImmediately = _ref$changeImmediatel === void 0 ? false : _ref$changeImmediatel,
      selected = _ref.value,
      update = _ref.update,
      setOpen = _ref.setOpen,
      change = _ref.change,
      empty = _ref.empty,
      confirmDisabled = _ref.confirmDisabled,
      showConfirm = _ref.showConfirm,
      _ref$showClear = _ref.showClear,
      showClear = _ref$showClear === void 0 ? false : _ref$showClear,
      _ref$onClear = _ref.onClear,
      onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear;
  return {
    onClose: function onClose() {
      if (!showConfirm && !changeImmediately) {
        change();
      }
    },
    confirmButtons: (showClear || showConfirm) && /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
      var locale = _ref2.locale;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showClear && /*#__PURE__*/React.createElement(Button, {
        "data-event-name": "clear",
        size: "mini",
        outline: true,
        onClick: function onClick() {
          onClear();
          update({
            value: empty
          });
        }
      }, getLocale(locale).common.clear), showConfirm && /*#__PURE__*/React.createElement(Button, {
        "data-event-name": "cancel",
        size: "mini",
        outline: true,
        onClick: function onClick() {
          setOpen(false);
        }
      }, getLocale(locale).common.cancel), showConfirm && /*#__PURE__*/React.createElement(Button, {
        "data-event-name": "confirm",
        disabled: confirmDisabled,
        size: "mini",
        semantic: "primary",
        onClick: function onClick() {
          setOpen(false);
          change(selected);
        }
      }, getLocale(locale).common.confirm));
    })
  };
}